import { Injectable } from "@angular/core";

import { EMPTY, Observable, of } from "rxjs";
import { catchError, finalize, map, tap } from "rxjs/operators";
import { RestService } from "./rest.service";
import { CONSTANTS } from "./constants";

// CONST FOR ROUTING
const IDAM_URL = "idam";

@Injectable({
  providedIn: "root",
})
export class IdamService {
  constructor(private rest: RestService) { }

  get refreshTokenValue(): string {
    return localStorage.getItem(CONSTANTS.refreshToken) ?? '';
  }

  get tokenValue(): string {
    return localStorage.getItem(CONSTANTS.token) ?? '';
  }

  refreshToken(refreshToken: {
    token: string;
    refreshToken: string;

  }): Observable<{ token: string; refreshToken: string }> {
    return this.rest.post$<{ token: string; refreshToken: string }>(
      `refreshToken`,
      refreshToken,
      true, 'idam'
    ).pipe(
      tap(token => {
        this.setToken(token.token, token.refreshToken);
      })
    );
  }

  checkToken(): Observable<{ token: string; refreshToken: string } | undefined> {
    if (this.tokenValue && this.tokenValue !== '' && this.refreshTokenValue !== '') {
      return this.refreshToken({ token: this.tokenValue, refreshToken: this.refreshTokenValue });
    }
    return of(undefined);

  }


  isLogged(): boolean {
    const tokenValue = this.tokenValue;
    return tokenValue !== undefined && tokenValue !== null && tokenValue !== '';
  }

  logout(): Observable<boolean> {

    if (this.isLogged()) {
      return this.rest.post$<{ success: boolean }>('logout', null, true, 'idam').pipe(

        tap(() => {
          localStorage.clear();
          //  void this.router.navigateByUrl('/login');
        }),
        map(res => {

          return res.success;
        }),
        catchError(() => {
          localStorage.clear();
          return EMPTY;
        }),
        finalize(() => {
          localStorage.clear();
          //void this.router.navigateByUrl('/login');
        })
      );
    } else {
      localStorage.clear();
      // void this.router.navigateByUrl('/login');
      return of(true);
    }


  }


  setToken(token: string, refreshToken: string): void {
    localStorage.setItem(CONSTANTS.token, token);
    localStorage.setItem(CONSTANTS.refreshToken, refreshToken);
  }


}
